import { Spacing } from '@persona-id/design-tokens';
import { components, SingleValueProps } from 'react-select';
import styled from 'styled-components';

import { OptionType } from 'dashboard/components/ReactSelect';
import AvailabilityCircle from 'dashboard/components-lib/AvailabilityCircle';
import { UserAvailability } from 'dashboard/models/user';

const StyledAvailabilityCircle = styled(AvailabilityCircle)`
  flex-shrink: 0;
  display: inline-block;
  margin-right: ${Spacing[2]};
`;

const UserListRowAvailabilitySingleValue = (
  props: SingleValueProps<OptionType<UserAvailability>>,
) => {
  return (
    <components.SingleValue {...props}>
      <StyledAvailabilityCircle availability={props.data.value} />
      <span>{props.data.label}</span>
    </components.SingleValue>
  );
};

export default UserListRowAvailabilitySingleValue;
